export default __webpack_public_path__ + "static/media/user.d7a185b7.svg";